import React from 'react';
import { DndProvider } from 'react-dnd';
import { Controller, useFormContext } from 'react-hook-form';
import { HTML5Backend } from 'react-dnd-html5-backend';

import FolderTree from './FolderTree';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

export default function FolderStructure({ index }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <DndProvider backend={HTML5Backend}>
      <Controller
        name={`actions[${index}].folderStructure`}
        control={control}
        rules={{ required: 'At least one folder is required' }}
        render={({ field }) => <FolderTree value={field.value} onChange={field.onChange} />}
      />
      <RequiredValidation errors={errors} field={`actions.${index}.folderStructure`} />
    </DndProvider>
  );
}
